import React, { useEffect, useState } from "react";
import MainDashboardLayout from "../../../../Layout/MainDashboardLayout";
import GRISidebar from "../../../../Layout/GRISidebar";
import styles from "../../../../styles/gri/general.module.css";
import InputField from "../../../../Components/Masters/InputField";
import { Box, Button, Checkbox, FormControlLabel } from "@mui/material";
import EastIcon from "@mui/icons-material/East";
import { get, put } from "../../../../utils/api";
import { useNavigate, useParams } from "react-router-dom";
import { validateNumber } from "../../../../utils/validateFields";
import MessagePopup from "../../../../Components/Masters/MessagePopup";
import { restructureData } from "../../../../utils/restructureData";
import DynamicStaticTable from "../../../../Components/Common/DynamicStaticTable";
import { validateLastRow } from "../../../../utils/validateTable";
import ReviewBox from "../../../../Components/Common/ReviewBox";

import { currentYear } from "../../../../utils/generateYearRanges";

const GRI305_4 = ({hide}) => {
   const [griReview, setGriReview] = useState(() => JSON.parse(localStorage.getItem("griReview")));
 const inputData = [
    {
      fieldName: "gasesIncluded",
      // title: "d. Gases included in the calculation:",
      type: "array",
      letter: "b.",
      fields: [
        {
          fieldName: "gasName",
          title: "Gas Name",
          type: "text",
          placeholder: "Enter Text",
          width: "44%",
        },
        // {
        //   fieldName: "unit",
        //   title: "Unit",
        //   type: "select",
        //   options: ["Tonns", "Liters", "M3", "Kg"],
        //   width: "30%",
        //   placeholder: "Select",
        // },
        {
          fieldName: "total",
          title: "Total Emission",
          type: "number",
          width: "44%",
          placeholder: "Enter Number",
        },
      ],
    },
  ];

  const defaultSegments = ["CO2", "CH4", "N2O", "HFCs", "PFCs", "SF6", "NF3"];

  const questionData = [
    {
      fieldName: "emissionsIntensityRatio",
      type: "text",
      heading: "a. GHG emissions intensity ratio for the organization",
    },
    {
      fieldName: "emissionsIntensityDenominator",
      type: "text",
      heading:
        "b. Organization-Specific metric (Denominator) chosen to calculate the ratio:",
    },
    {
      fieldName: "includedGHGEmissions",
      type: "checkbox",
      options: ["Scope 1", "Scope 2", "Scope 3"],
      heading: "c. Types of GHG emissions included in the intensity ratio:",
    },
  ];

  const navigate = useNavigate();
  const { id } = useParams();
  const [disabled, setDisabled] = useState(false);
  const [errors, setErrors] = useState({});
  const [tables, setTables] = useState([]);
  const [tabErrors, setTabErros] = useState({});
  const [data, setData] = useState({});
  const [formData, setFormData] = useState({});
  const [snackOpen, setsnackOpen] = useState({
    open: false,
    message: "",
    severity: "",
  });

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const res = await get(`/gri/get?Id=${id}&type=GRI300`);
      if (res?.data?.data?.year ? res?.data?.data?.year < currentYear -1 : false) setDisabled(true);
      const res1 = res?.data?.data?.GRI300?.intensity;
      setData(res1);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    // Ensure formData?.includedGHGEmissions is always an array
    setFormData({
      emissionsIntensityRatio: data?.emissionsIntensityRatio || "",
      emissionsIntensityDenominator: data?.emissionsIntensityDenominator || "",
      includedGHGEmissions: Array.isArray(data?.includedGHGEmissions)
        ? data?.includedGHGEmissions
        : [], // If data is not an array, initialize as an empty array
    });
  }, [data]);

  const handleChange = (fieldName, value, type, checked) => {
    if (type === "number" && !validateNumber(value)) return;

    setFormData((prev) => {
      if (fieldName === "includedGHGEmissions") {
        let newGHGEmissions = [...prev[fieldName]]; // Copy the array to avoid mutation

        // If checkbox is checked, add the value to the array
        if (checked) {
          if (!newGHGEmissions.includes(value)) {
            newGHGEmissions.push(value);
          }
        } else {
          // If checkbox is unchecked, remove the value from the array
          newGHGEmissions = newGHGEmissions.filter((item) => item !== value);
        }

        // Return the updated state
        return {
          ...prev,
          [fieldName]: newGHGEmissions,
        };
      } else {
        // Handle other fields (non-checkbox)
        return {
          ...prev,
          [fieldName]: value,
        };
      }
    });
  };

  const handleSubmit = async () => {
    if (!disabled) {
      if (
        tables?.[0]?.rows?.length > defaultSegments?.length &&
        !validateLastRow(inputData, tables, setTabErros)
      )
        return;
      let transformedData2 = {
        intensity: { ...restructureData(tables), ...formData },
        type: "GRI300",
        submitted305_4: true,
      };

      try {
        const res = await put(`/gri/update?Id=${id}`, transformedData2);
        setsnackOpen({
          open: true,
          message: res.data.message,
          severity: "success",
        });
        navigate(`/gri/gri300/305-5/${id}`);
      } catch (error) {
        setsnackOpen({
          open: true,
          message: error.data.message,
          severity: "error",
        });
      }
    } else {
      navigate(`/gri/gri300/305-5/${id}`);
    }
  };


  const renderContent = ({hide}) => (
       <>
      <MessagePopup {...{ snackOpen, setsnackOpen }} />{" "}
      {!hide && <p className={styles.section_heading}>305 : Emissions</p>}
      <p className={styles.main_heading} style={{marginBottom : hide ? "-0.5rem" : "0", }}>305-4 : GHG emissions intensity </p>
      <Box sx={{ mt: hide ? "-2rem" : "2rem" }}>
        {questionData.map((el) => (
          <Box key={el.fieldName} sx={{ mt: "2rem" }}>
            <p className={styles.ques_heading}>{el.heading}</p>
            {el?.options ? (
              el?.options.map((option) => {
                console.log(
                  "option",
                  option,
                  formData?.includedGHGEmissions,
                  formData?.includedGHGEmissions?.includes(option)
                );
                return (
                  <FormControlLabel
                    key={option}
                    sx={{ ml: 1, display: "flex", mt: "-0.5rem" }}
                    control={
                      <Checkbox
                        value={option}
                        onChange={(e) =>
                          handleChange(
                            el?.fieldName,
                            option,
                            el?.type,
                            e.target.checked
                          )
                        }
                        checked={
                          formData?.includedGHGEmissions?.includes(option) ||
                          false
                        } // Ensure it's always a boolean
                        disabled={disabled}
                      />
                    }
                    label={option}
                  />
                );
              })
            ) : (
              <Box sx={{ ml: 2.5 }}>
                <InputField
                  placeholder={"Enter Text"}
                  fieldName={el.fieldName}
                  value={formData?.[el.fieldName]}
                  handleChange={(e) =>
                    handleChange(el?.fieldName, e.target.value, el?.type)
                  }
                  mt="-5px"
                  errors={Boolean(errors[el.fieldName])}
                  disabled={disabled}
                />
              </Box>
            )}
          </Box>
        ))}
      </Box>
      <Box sx={{ display: "flex", gap: 1, mt: hide ? "-1rem" : "1rem" , mb: hide ? "-1rem" : "0"  }}>
        <p className={styles.ques_heading}>
          d. Gases included in the calculation:
        </p>
        <p className={styles.ques_heading}>Tons</p>
      </Box>
      <DynamicStaticTable
        {...{
          inputData,
          tables,
          setTables,
          errors: tabErrors,
          setErrors: setTabErros,
          data: data,
          defaultSegments,
          parameter: "gasName",
          buttonHeading: "Add Other Gases",
          disabled: disabled,
          hide : hide 
        }}
      />
     
    </>
  )

  return (
  <>
      {!hide ? (
        <MainDashboardLayout sidebar={<GRISidebar />}>
          {renderContent({ hide })}

          <>
             {!griReview ? (
        <Box sx={{ ml: "1rem", width: "98%" }}>
          <ReviewBox url={"/gri"} handleSubmit={handleSubmit} />
        </Box>
      ) : (
        <Box textAlign="right" sx={{ mt: 3 }}>
          <Button
            onClick={handleSubmit}
            variant="contained"
            sx={{ bgcolor: "#1C486B", textTransform: "none", mt: 3, mb: 5 }}
          >
            Save & Continue <EastIcon sx={{ ml: 2 }} />
          </Button>
        </Box>
      )}
          </>
        </MainDashboardLayout>
      ) : (
        renderContent({ hide })
      )}
    </>
  );
};

export default GRI305_4;
